<template>
  <draggable v-model="photos" class="row">
    <v-col cols="3" md="2" v-for="(photo, index) in photos" :key="photo.key">
      <v-card class="mt-2 mb-2 item photo-card" color="grey lighten-4" flat>
        <delete-modal
          @confirm="remove(index)"
          subtitle="Jeste li sigurni da želite obrisati ovu fotografiju?"
          title="Obriši fotografiju" />

        <!-- Teaser checkbox -->
        <v-checkbox
          v-model="photo.teaser"
          class="teaser-checkbox"
          hide-details
          dense
          :true-value="true"
          :false-value="false"
          label="Teaser"
          @click.stop
          @mousedown.stop
        />

        <a :href="getLink(photo)" target="_blank" rel="noopener">
          <v-img :src="photo.sizes.SM.location" aspect-ratio="1" />
        </a>
      </v-card>
    </v-col>
  </draggable>
</template>

<script>
import isEqual from 'lodash/isEqual';
import DeleteModal from '../../common/DeleteModal';
import Draggable from 'vuedraggable';
import Vue from 'vue';

export default {
  name: 'property-gallery',
  props: {
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      photos: this.withTeaserDefault(this.value)
    }
  },
  methods: {
    withTeaserDefault(list) {
      return (list || []).map((p) => {
        if (typeof p.teaser === 'undefined') Vue.set(p, 'teaser', false);
        return p;
      });
    },
    getLink(photo) {
      const availableSize = photo.sizes.XL || photo.sizes.ORIGINAL;
      return availableSize.location;
    },
    remove(index) {
      this.photos.splice(index, 1);
    }
  },
  watch: {
    value() {
      if (!isEqual(this.value, this.photos)) {
        this.photos = this.withTeaserDefault(this.value);
      }
    },
    photos: {
      deep: true,
      handler() {
        this.$emit('input', this.photos);
      }
    }
  },
  components: { DeleteModal, Draggable }
}
</script>

<style lang="scss" scoped>
.photo-card {
  position: relative;
}

::v-deep .delete-icon {
  position: absolute !important;
  top: 0.25rem;
  right: 0.25rem;
  color: #B71C1C !important;
  border-radius: 50% !important;
  z-index: 2;
  cursor: pointer;
  background: #fff;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
}

.teaser-checkbox {
  position: absolute;
  top: 0.1rem;
  left: 0.25rem;
  z-index: 2;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  padding: 0 6px;
}

::v-deep .teaser-checkbox .v-label {
  font-size: 12px;
}
</style>
